import { Autocomplete, TextField } from "@mui/material";
import { useState, useEffect, useContext } from "react";
import InventoryTracking from "../../api/InventoryTracking";
import { AuthContext } from "../../context/AuthContext";

const SelectJob = ({ value, onUpdate, disabled, enableAdd, ...props }) => {
  const { authToken } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [jobs, setJobs] = useState([]);
  const [search, setSearch] = useState("");

  const getJobs = async () => {
    try {
      const response = await InventoryTracking.get(
        // `/jobs?search=${escapeCharacters(search)}&location=SDL`,
        `/jobs?location=SDL`,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        },
      );
      console.log(response.data);
      setJobs(response.data.jobs);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (disabled) {
      setJobs([]);
    } else {
      getJobs();
    }
  }, [disabled]);

  if (jobs)
    return (
      <Autocomplete
        size="small"
        disablePortal
        inputValue={search}
        onInputChange={(event, newInputValue) => {
          setSearch(newInputValue);
        }}
        options={jobs}
        renderInput={(params) => (
          <TextField size="small" label="Select Job" {...params} autoFocus />
        )}
        onChange={(event, value) => {
          onUpdate(value ?? null);
        }}
        getOptionLabel={(option) => {
          //    Return Searchable String for Each Option
          let label = `${option.projectid} - ${option.job_name} - ${option.customer_name}`;

          return label;
        }}
        selectOnFocus
        clearOnBlur
        isOptionEqualToValue={(option, value) => {
          // console.log("isOptionEqualToValue", option, value);
          //  The "selected" prop on renderOption depends on this
          return value.id == option.id;
        }}
      />
    );
};

export default SelectJob;
